export const getTop3Path = (tenant, location, addition = null) => {
  const search = new URLSearchParams();

  if (addition) {
    search.set('addition', addition);
  }

  if (location) {
    search.set('oncancel', location.pathname);
  }

  const searchStr = search.toString() ? `?${search.toString()}` : '';

  return `/${tenant.name.toLowerCase()}/career-path/top-3${searchStr}`;
};
